import { axios } from '@/utils/request'

/**
 * 查询中成药/西药信息表
 *
 * @author 李伟
 * @date 2022-04-04 17:15:56
 */
export function baMedicinePage (parameter) {
  return axios({
    url: '/baMedicine/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 中成药/西药信息表列表
 *
 * @author 李伟
 * @date 2022-04-04 17:15:56
 */
export function baMedicineList (parameter) {
  return axios({
    url: '/baMedicine/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加中成药/西药信息表
 *
 * @author 李伟
 * @date 2022-04-04 17:15:56
 */
export function baMedicineAdd (parameter) {
  return axios({
    url: '/baMedicine/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑中成药/西药信息表
 *
 * @author 李伟
 * @date 2022-04-04 17:15:56
 */
export function baMedicineEdit (parameter) {
  return axios({
    url: '/baMedicine/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除中成药/西药信息表
 *
 * @author 李伟
 * @date 2022-04-04 17:15:56
 */
export function baMedicineDelete (parameter) {
  return axios({
    url: '/baMedicine/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出中成药/西药信息表
 *
 * @author 李伟
 * @date 2022-04-04 17:15:56
 */
export function baMedicineExport (parameter) {
  return axios({
    url: '/baMedicine/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 字典表
 *
 * @author zhangyy
 * @date 2022-05-12 17:56:31
 */
export function baDatadictDetailList (parameter) {
  return axios({
    url: '/baDatadictDetail/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 字典表药 药房
 *
 * @author zhangyy
 * @date 2022-05-12 17:56:31
 */
export function babaPharmacyList (parameter) {
  return axios({
    url: '/baPharmacy/list',
    method: 'get',
    params: parameter
  })
}
